var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _vm.solicitud.estado === "EN_CAPTURA"
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "apeironGwApp.fechasTutorias.mensajes.mensajeConfirmar"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCapturable()
            ? _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasTutorias.label.fechaInicioBeca"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaInicioBeca",
                                  placeholder: "",
                                  max: new Date(),
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value:
                                    _vm.solicitud.beca.periodoBeca
                                      .fechaInicioBeca,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud.beca.periodoBeca,
                                      "fechaInicioBeca",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.beca.periodoBeca.fechaInicioBeca",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasTutorias.label.fechaFinBeca"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaFinBeca",
                                  placeholder: "",
                                  max: new Date(),
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value:
                                    _vm.solicitud.beca.periodoBeca.fechaFinBeca,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud.beca.periodoBeca,
                                      "fechaFinBeca",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.beca.periodoBeca.fechaFinBeca",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasTutorias.label.duracionBeca"
                                ),
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "duracionBecaMeses",
                                  disabled: "",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.duracionBecaMeses,
                                  callback: function ($$v) {
                                    _vm.duracionBecaMeses = $$v
                                  },
                                  expression: "duracionBecaMeses",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasTutorias.label.fechaInicioTutoria"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaInicioTutoria",
                                  placeholder: "",
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value: _vm.solicitud.fechaInicioTutoria,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "fechaInicioTutoria",
                                      $$v
                                    )
                                  },
                                  expression: "solicitud.fechaInicioTutoria",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasTutorias.label.fechaFinTutoria"
                                ),
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  locale: "es",
                                  id: "fechaFinTutoria",
                                  placeholder: "",
                                  "value-as-date": false,
                                  disabled: "",
                                  "date-format-options": {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  },
                                },
                                model: {
                                  value: _vm.solicitud.fechaFinTutoria,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "fechaFinTutoria",
                                      $$v
                                    )
                                  },
                                  expression: "solicitud.fechaFinTutoria",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                label: _vm.$t(
                                  "apeironGwApp.fechasTutorias.label.duracionTutoria"
                                ),
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "duracionTutoriadMeses",
                                  disabled: "",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.solicitud.duracionTutoriadMeses,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud,
                                      "duracionTutoriadMeses",
                                      $$v
                                    )
                                  },
                                  expression: "solicitud.duracionTutoriadMeses",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _vm.showNotaMeses
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-alert",
                                { attrs: { show: "", variant: "warning" } },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.showMessage),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isCapturable()
        ? _c(
            "b-col",
            { attrs: { md: "2" } },
            [
              _vm.solicitud.beca
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        id: "refrescar",
                        variant: "primary",
                        block: "",
                        disabled: !(_vm.solicitud.estado === "EN_CAPTURA"),
                      },
                      on: { click: _vm.confirmaPeriodoChange },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "apeironGwApp.fechasTutorias.label.confirmarPeriodo"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "save" }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }